import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { AppState } from '../../../app.reducer';
import { SessionService } from '../../../core/services/session.service';
import { Store } from '@ngrx/store';
import { getUser } from '../../../core/store/actions/core.actions';
import { IClient } from '../../../shared/interfaces/IClient';
import { first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-thanks-page',
  templateUrl: './thanks-page.component.html',
  styleUrls: ['./thanks-page.component.scss']
})
export class ThanksPageComponent implements OnInit {
  private apiUrl = environment.apiUrl;
  user: IClient;
  
  constructor(
    private router: Router, 
    private httpClient: HttpClient, 
    private sessionService: SessionService, 
    private http: HttpClient,
    private store: Store<AppState>,
    
    ) { }

  ngOnInit() {
    this.store.select('core').pipe(
      map(state => state.user)
      )
      .subscribe(user => {
        if (user) {
          this.sendMail(user.id);
        }
      });
      

  }

  volver(): void {
    this.router.navigateByUrl(`/`);
  }

  sendMail(id): void {
    const url = this.apiUrl + 'sendMailConfirmation';
    const body = { user_id: id };

    this.http.post(url, body).subscribe(
      response => {
        console.log('Respuesta del servidor:', response);
      },
      error => {
        console.error('Error al enviar el correo:', error);
      }
    );
    
    
    
  }
}
